var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},[_c('canvas',{ref:"canvas",staticStyle:{"position":"absolute","height":"100%","width":"100%","background-color":"black","left":"0","top":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }